const initialState = null;

export default (state = initialState, {type, payload}) => {
	switch (type) {
		case "SIGN_OUT":
			return initialState;
		case "ADD_KEYFIELDS":
			return payload;
		case "REMOVE_KEYFIELDS":
			return [];
		default:
			return state;
	}
};
